import { Pill } from '../../components/ui/index.jsx';
import VerifiedBadge from '../../components/ui/VerifiedSeal.jsx';
import { DOMAIN_STATUS } from './domainMeta.js';

/** A domain's ownership: the seal when verified, a pill otherwise. */
export default function DomainStatus({ status }) {
  if (status === 'verified') return <VerifiedBadge />;
  const s = DOMAIN_STATUS[status] || DOMAIN_STATUS.unverified;
  return <Pill tone={s.tone}>{s.label}</Pill>;
}
